import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

import {
  MobileAddressAutocompleteField,
  type SelectedAddress,
} from "./MobileAddressAutocompleteField";

export interface Step1Data {
  patientName: string;
  address: string;
  oasis: boolean;
}

interface Props {
  data: Step1Data;
  /** Locked once visits exist, since the address feeds each visit's rate config. */
  addressLocked: boolean;
  onChange: (field: keyof Step1Data, value: string | boolean) => void;
  onAddressSelect: (address: SelectedAddress) => void;
}

const inputSx = {
  bgcolor: "background.paper",
  borderRadius: 2,
  "& .MuiOutlinedInput-root": { borderRadius: 2 },
};

/** Patient-level fields for a new case (name, OASIS, address). Visits are added separately. */
export function MobileCreateCaseStep1({ data, addressLocked, onChange, onAddressSelect }: Props) {
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Text semibold variant="body1">
          What&apos;s the patient name?
        </Text>
        <TextField
          fullWidth
          placeholder="Ilorum ipsum, etc..."
          value={data.patientName}
          onChange={(e) => {
            onChange("patientName", e.target.value);
          }}
          sx={inputSx}
          inputProps={{ "data-dd-privacy": "mask" }}
        />
      </Stack>

      <FormControlLabel
        control={
          <Checkbox
            checked={data.oasis}
            onChange={(e) => {
              onChange("oasis", e.target.checked);
            }}
          />
        }
        label="OASIS"
      />

      <Stack spacing={1}>
        <Text semibold variant="body1">
          What&apos;s the address?
        </Text>
        <MobileAddressAutocompleteField
          value={data.address}
          placeholder="Start typing an address..."
          disabled={addressLocked}
          onInputChange={(addressValue) => {
            onChange("address", addressValue);
          }}
          onSelect={onAddressSelect}
          sx={inputSx}
        />
        {addressLocked ? (
          <Text variant="body2" sx={{ color: "text.secondary" }}>
            Remove all visits to change the address.
          </Text>
        ) : null}
      </Stack>
    </Stack>
  );
}
